// const intialState = {
// userInfo: {
//   user: {
//     name: '小李'
//   },
//   userDetail: {}
// }
// };

export default {
  state: {
    // userInfo: intialState.userInfo

  },
  getters: {
    // GTT_UserName: state => state.userInfo.user.name
  },
  actions: {},
  mutations: {}
};
